import React, { useContext } from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";
import { Link } from "react-router-dom";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ALL_TARIFFS_QUERY } from "../../graphql/Tariffs/Tariffs.graphql";
import { ourToast as toast } from "../../utils";
import { ModalContext } from "../ModalProvider";
import { useCurrentUserRoles } from "../Authorization";

const TariffSelect = ({
  value,
  label,
  size,
  valueKey,
  name,
  onChange,
  icon,
  where,
  disabled,
  showHelp = false,
  orderByMulti = ["TariffCode_ASC"]
}) => {
  const { setModalOpen } = useContext(ModalContext);
  const roles = useCurrentUserRoles();
  const { data, loading, error } = useQuery(ALL_TARIFFS_QUERY, {
    variables: { where, orderByMulti }
  });
  if (error) {
    toast.error("Error getting Tariffs.");
  }

  const selectedTariff = data?.Tariffs?.find(t => t.RecId === parseInt(value));
  const isAdmin = roles.some(role => role === "ADMIN");
  const isBill = roles.some(role => role === "FIN");

  return (
    <Field>
      {showHelp && (isAdmin || isBill) ? (
        <Label
          as={Link}
          tabIndex="-1"
          textColor="link"
          to={
            selectedTariff
              ? `/finance/tariffs/${selectedTariff?.RecId}/details`
              : "/finance/tariffs/"
          }
          onClick={() => setModalOpen(false)}
        >
          {label}
        </Label>
      ) : (
        <Label size={size}>{label}</Label>
      )}
      <Field kind={showHelp ? "addons" : ""}>
        <Control expanded iconLeft={!!icon} size={size}>
          <Select.Container
            fullwidth
            color={error ? "danger" : "secondary"}
            size={size}
            state={loading ? "loading" : null}
          >
            {data && data.Tariffs ? (
              <Select
                disabled={disabled}
                name={name}
                value={value}
                onChange={onChange}
              >
                <Select.Option value={0}>{label}</Select.Option>
                {!loading &&
                  data.Tariffs.map(({ TariffCode, Active, ...keys }, i) => (
                    <Select.Option
                      key={`product-select-${i}`}
                      style={{ display: Active ? "unset" : "none" }}
                      value={keys[valueKey]}
                    >
                      {TariffCode}
                    </Select.Option>
                  ))}
              </Select>
            ) : null}
          </Select.Container>
          {icon && (
            <Icon align="left" size="small">
              <FontAwesomeIcon icon={icon} />
            </Icon>
          )}
        </Control>
      </Field>
    </Field>
  );
};
TariffSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  valueKey: PropTypes.string,
  icon: PropTypes.string,
  where: PropTypes.object,
  disabled: PropTypes.bool,
  showHelp: PropTypes.bool,
  orderByMulti: PropTypes.array
};

TariffSelect.defaultProps = {
  value: 0,
  valueKey: "RecId",
  where: {}
};
export default TariffSelect;
